
export const types = {
  CAST_NOT_ALLOWED: 'Player/CAST_NOT_ALLOWED',
  CLEAN_UP: 'Player/CLEAN_UP',
  PLAYBACK_ERROR: 'PLayer/PLAYBACK_ERROR',
  SET_INSTANCE: 'Player/SET_INSTANCE',
  SET_IS_CASTING: 'Player/SET_IS_CASTING',
  UPDATE_DURATION: 'Player/UPDATE_DURATION',
  UPDATE_FULLSCREEN_STATUS: 'Player/UPDATE_FULLSCREEN_STATUS',
  STOP_NEXT_EPISODE: 'Player/STOP_NEXT_EPISODE'
};

export const TBX_PLAYER_ENVS = new Map([
  ['cert', 'certification'],
  ['certification', 'certification'],
  ['development', 'development'],
  ['production', 'production'],
]);